import { defer, LoaderFunction } from 'react-router-dom'

import { PaginatedResponse } from '@custom-types/response'
import Score from '@models/Score'
import ApiRoutes from '@utils/api-routes'
import http from '@utils/http'

export type FavoriteScoresResponse = { scores: Score[] } & PaginatedResponse

export type FavoritesLoaderResponse = {
  favoriteScores: Promise<FavoriteScoresResponse>
  order: string | null
}

export const FAVORITES_PAGE_SIZE = 15

const favoritesLoader: LoaderFunction = async ({ request }) => {
  const url = new URL(request.url)

  const order = url.searchParams.get('order')
  const favoriteScores = http.loader.post(ApiRoutes.members.favoriteScoresPath(), {
    order,
    max_count: FAVORITES_PAGE_SIZE,
  })
  return defer({ favoriteScores, order })
}

export default favoritesLoader
